import {useState, useEffect, useContext, useCallback} from 'react';
import {useParams} from "react-router";
import {APIGetMyMaps} from "../../api/maps/Maps";
import CardGrid from "../../components/cardview/cardGrid";
import {LoadingIndicator} from '../../components/loadingIndicator/loadingIndicator';
import NotFoundMap from "../../assets/map.jpg";
import {ListContext} from "../../context/ListContext";
import {UserContext} from '../../context/UserContext';
import {verifyPermissions} from "../../helper/getProductSettingsHandler";

export const MapsIndex = ({data}) => {
	const {user,company} = useContext(UserContext);
	const {type} = useParams();
	const [list, setList] = useState(null);


	const settings = {
		all: {
			type:"myMaps",
			title:"Karten",
			limit:verifyPermissions(company, "mapsMax"),
			creationAllowed:verifyPermissions(company, "mapsCreation"),
			creationLabel:"Neue Karte erstellen",
			creationType:"map",
			upgrade: '/products/moreMaps',
			createDialog:{
				image:NotFoundMap,
				text: "Es wurde noch keine Karte erstellt."
			},
			deleteDialog:{
				headline:"Karte löschen",
				text: "Mit Löschung wird die Karte gelöscht und ist somit auch nicht mehr Aufrufbar. Bitte prüfen Sie vor der Löschung, ob der Link zur Karte noch auf Ihrer Homepage oder anderen öffentlichen Seiten hinterlegt ist. Die Löschung der Karte hat keine Auswirkung auf die Ihr zugewiesenen Pläne. Diese belieben von der Löschung unberührt.",
				button: "Endgültig löschen"
			},
			search:{
				searchAllows:verifyPermissions(company, "mapsSearch"),
				text:"Kartenname",
			},
			actions:{
				orderDelete:false,
				orderCreation:false,
				planCreation:false,
				planDelete:false,
				planCertificatedCreate:false,
				planLinkViewer:false,
				mapCreation:verifyPermissions(company, "mapsCreation"),
				mapDelete:verifyPermissions(company, "mapsDelete"),
				mapLinkCopy:verifyPermissions(company, "mapsShareLink"),
				mapWFS:true,
				mapViewer:true,
				mapLinkViewer:true,
			},
			tableColumns: {
				createdAt:"Erstellt am",
				name:"Name",
				mapAssignments:"Enhaltene Pläne",
			}
		}
	}

	const fetchListData = useCallback(async () => {
		const maps = await APIGetMyMaps(user?.companyId);
		setList(maps);
	}, [user?.companyId]);

	useEffect(() => {

		if (user === undefined) { return; }
	  
		fetchListData();

	}, [fetchListData, user]);


	const currentSetting = settings?.[(typeof type !== "undefined")? type : "all"];
	const currentUpload =   null;


	return list === null ? (
        <div className='flex w-full h-dvh justify-center items-center'>
            <LoadingIndicator/>
        </div>
    ) : (
		<div className={"mx-auto max-w-7xl orderDetails"}>
			<main>
				<div className="w-full flex">
					<ListContext.Provider value={{list, setList, type, currentSetting, currentUpload, fetchListData}}>
						<CardGrid/>
					</ListContext.Provider>
				</div>
			</main>
		</div>
	)

}
